import type { Component, Input } from '@builder.io/sdk';

export const podcastFields = [
  {
    name: 'embed',
    type: 'longText',
  },
] as const satisfies DeepReadonly<Input[]>;

const podcastConfig = {
  name: 'HCI Podcast',
  inputs: podcastFields,
} satisfies Component;

export type PodcastConfigProps = GenerateBuilder<typeof podcastFields>;

export default podcastConfig;
